import {Provider} from '@angular/core';

import {DefaultPortalConfig, PortalConfig} from './portal-config';

export const PortalConfigFactory = () => {
  // Read the config set up by the BFF on the global window object

  const browserWindow = globalThis as typeof globalThis & Record<string, unknown>; // global object might be undefined if this is run outside the browser
  const config = (browserWindow['__cwp_boot'] as PortalConfig | undefined) ?? DefaultPortalConfig;

  const themeColour = config.themeColour;
  const fontFamily = config.fontFamily;
  const fontColour = config.fontColour;
  const termsAvailable = config.termsAvailable;
  const accessibilityAvailable = config.accessibilityAvailable;
  const supportMessage = config.supportMessage;

  return new PortalConfig(
    themeColour,
    fontFamily,
    fontColour,
    false, // removeLogo - removed from API
    termsAvailable,
    accessibilityAvailable,
    supportMessage,
    false, // samlEnabled - removed from API
    undefined // samlIdpLoginUrl - removed from API
  );
};

export const PortalConfigProvider: Provider = {
  provide: PortalConfig,
  useFactory: PortalConfigFactory,
  deps: [],
};
